import { type StructuredAddress, type AddressWithLatLong } from './Model/Geocode';
import Resource from 'Resources/Resource';

type LookupAddressOpts = {
	lookupIfNotFound?: boolean;
};

class Geocode extends Resource {
	constructor() {
		super('geocode');
	}

	lookupAddress(
		address: StructuredAddress,
		opts: LookupAddressOpts = {}
	): Promise<{ data: AddressWithLatLong | null }> {
		return super.get('address', { params: { ...address, ...opts } });
	}

	lookupLatLong(latitude: number, longitude: number): Promise<{ data: AddressWithLatLong }> {
		return super.get('latLong', { params: { latitude, longitude } });
	}
}

const resource = new Geocode();

export default resource;
